//@ts-nocheck

import Link from 'next/link'
import React from 'react'
import Slider from 'react-slick'
// import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useRouter } from 'next/router'
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/right-icon-black.svg" alt="RightArrow" />
    </div>
  )
}

function SamplePrevArrow(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/left-icon-black.svg" alt="LeftArrow" />
    </div>
  )
}
interface categoryData {
  slug?: string
  name: string
  description?: string
  bannerImage?: string
  image?: string
  __typename?: string
}

interface CategorySmallBannerProps {
  categoryData: categoryData[]
  scrollY: number
  handleClose: () => void
  pathname: string
}

export default function CategorySmallBanner({
  categoryData,
  scrollY,
  handleClose,
  pathname,
}: CategorySmallBannerProps) {
  const router: any = useRouter()

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 12,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        },
      },
    ],
  }

  return (
    <div
      className={`book-application-shop-by-category-small-banner-alignment ${
        scrollY >= 100 ? 'open-nav-alignment' : 'hide-nav-alignment'
      }`}
    >
      <div className="container" style={{ padding: 0 }}>
        <div className="book-application-shop-by-category-small-banner-flex">
          <div className="book-application-shop-by-category-option">
            <Slider {...settings}>
              {categoryData?.map((cat, index) => (
                <div>
                  <div className="book-application-shop-by-category-link-alignment" key={index}>
                    <Link href={`${pathname}/${cat?.slug}`} scroll={false}>
                      <p className={router?.query?.id?.toLowerCase() === cat?.slug?.toLowerCase() ? 'menu-active' : ''}>
                        {cat?.name}
                      </p>
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  )
}
